export default __webpack_public_path__ + "static/plp--blanco--mobile-52bb7840c3ca5e608c77f91678fd4981.jpg";